"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * normalizador del modulo MODULO INFORMACION_ADICIONAL DE ROAMING
 * @param {object} fields
 * @returns
 */
const roamingInfoNormalizer = (data) => {
    var _a;
    try {
        let res = null;
        const listadoPaises = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.ListadoPaises;
        if (listadoPaises &&
            Array.isArray(listadoPaises) &&
            listadoPaises.length > 0) {
            const normalizedInfo = {};
            listadoPaises.map((item, index) => {
                const { fields } = item;
                const paises = fields === null || fields === void 0 ? void 0 : fields.paises;
                if (paises && Array.isArray(paises) && paises.length > 0) {
                    paises.map((pais, index2) => {
                        normalizedInfo[`Pais-${index + 1}-${index2 + 1}`] = {
                            title: fields.title ? fields.title : "",
                            description: fields.description ? fields.description : "",
                            pais: pais,
                            typeMovil: fields.typeMovil
                        };
                    });
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = roamingInfoNormalizer;
//# sourceMappingURL=index.js.map